export const EMPTY_SELECTION = {
  keys: [],
  byKey: {},
  lastClickedKey: null,
  isComplete: false,
  context: null,
  source: null,
};
